(function(){    
    jQuery(window).on("load",function(){
        if( jQuery(window).width() > 1300 ) {
            jQuery(".content__main").mCustomScrollbar();
        }

        $( window ).resize(function() {
            if( jQuery(window).width() > 1300 ) {
                jQuery(".content__main").mCustomScrollbar();
            } else {
                jQuery(".content__main").mCustomScrollbar("destroy"); //destroy scrollbar 
            }
        });
    });
})();